<ng-template [ngIf]="utenteForm && display">
	<div>
	    <div class="col-sm-12 coldx">
	        <h4>{{title}}</h4>
	
	        <form #f="ngForm" [formGroup]="utenteForm" (ngSubmit)="update();">
				<div class="row">
					<div textInput [control]="utenteForm.controls['nome']"
						class="col-sm-4" [labelInput]="'Nome'" formControlName="nome"
						[mandatory]="true" [(ngModel)]="request.nome"></div>
						
					<div textInput [control]="utenteForm.controls['cognome']"
						class="col-sm-4" [labelInput]="'Cognome'" formControlName="cognome" [autocomplete]="'family-name'"
						[mandatory]="true" [(ngModel)]="request.cognome"></div>
						
					<div textInput [control]="utenteForm.controls['codiceFiscale']" [checkFormat]="true"
						class="col-sm-4" [labelInput]="'Codice Fiscale'" formControlName="codiceFiscale" [maxLength]="'16'"
						[mandatory]="true" [(ngModel)]="request.codiceFiscale"></div>
				</div>
				<div class="row">
					<div textInput [control]="utenteForm.controls['username']" [submitPending]="!inserimento"
						class="col-sm-4" [labelInput]="'Username'" formControlName="username"
						[mandatory]="true" [(ngModel)]="request.username"></div>
						
					<div textInput [control]="utenteForm.controls['email']"
						class="col-sm-4" [labelInput]="'Indirizzo email'" formControlName="email" [autocomplete]="'email'"
						[mandatory]="true" [(ngModel)]="request.email" [checkFormat]="true"></div>
						
					<div textInput [control]="utenteForm.controls['pec']"
						class="col-sm-4" [labelInput]="'P.E.C.'" formControlName="pec"
						[(ngModel)]="request.pec" [checkFormat]="true"></div>
				</div>
				<div class="row">
					<div comboModInput [control]="utenteForm.controls['templateProfilo']"
						[mandatory]="true" class="col-sm-12" [labelInput]="'Template di profilo'"
						formControlName="templateProfilo" [objectReference]="templateUtente"
						[ngModel]="templateUtente" (change) = "onChangeTemplate(templateUtente.id)"
						(onReturn)="templateUtente = $event"
						[optionsCombo] ="listaTemplateUtente"></div>
				</div>
				<div class="row">
					<p class="col-md-12 mandatory"><em>* Campi obbligatori</em></p>
				</div>
				<div class="row">
					<p class="col-sm-3 col-xs-6">
						<button type="button" class="btn btn-outline-secondary btn-block" (click)="createForm();">Reset</button>
					</p>
					<p submitButton
						class="col-sm-3 col-xs-6 col-sm-offset-6"
						[labelButton]="'Salva'" [disabled]="!utenteForm.valid"></p>	
				</div>
	
	        </form>
	
	    </div>
	
	</div>
</ng-template>